import Layout from '@/components/feature/Layout';
import useSEO from '@/hooks/useSEO';
import SEOJsonLd from '@/components/base/SEOJsonLd';
import ContactInfoContent from './components/ContactInfoContent';

export default function ContactInfoPage() {
  const siteUrl = (window as any).__VITE_SITE_URL__ || 'https://kangyong.com';
  useSEO({
    title: '聯絡資訊｜康永生技地址・電話・LINE・Email',
    description: '康永生技聯絡資訊：台中市北區中清路一段79號6樓，電話 (04)-22029858，Email natural1070606@gmail.com，LINE@ @126uwznp。營業時間週一至五 09:00-18:00。',
    keywords: '康永聯絡資訊,康永地址,康永電話,康永LINE,保健食品代工聯絡',
    lang: 'zh-TW',
    canonicalPath: '/contact/info',
  });

  return (
    <Layout>
      <SEOJsonLd type="WebPage" pageTitle="聯絡資訊｜康永生技地址・電話・LINE・Email" pageDescription="康永生技聯絡資訊：台中市北區中清路一段79號6樓，電話 (04)-22029858，Email natural1070606@gmail.com，LINE@ @126uwznp。" pageUrl={`${siteUrl}/contact/info`} />
      <ContactInfoContent />
    </Layout>
  );
}